<template>
	<v-dialog v-model="showDialog" :max-width="modalWidth" persistent>
		<v-card>
			<v-card-text class="text-center">{{
				message || 'Are you sure?'
			}}</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-btn v-if="showNoBtn" @click.stop="onCancel" color="error">{{
					noBtnText || 'No'
				}}</v-btn>
				<v-spacer />
				<v-btn
					v-if="showYesBtn"
					@click.stop="onConfirm"
					color="primary"
					>{{ yesBtnText || 'Yes' }}</v-btn
				>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
export default {
	name: 'ConfirmModalDialog',
	props: {
		showDialog: Boolean,
		message: String,
		showNoBtn: Boolean,
		showYesBtn: Boolean,
		yesBtnText: String,
		noBtnText: String,
		modalWidth: String,
	},
	methods: {
		onCancel() {
			this.$emit('cancel');
		},
		onConfirm() {
			this.$emit('confirm');
		},
	},
};
</script>
